<template>
  <div class="classification">
    <div class="search-box">
      <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <div class="box-inline">
          <!-- <a-form-model-item label="行业名称">
            <a-input v-model="form.industryCategoryName" placeholder="请输入行业名称" />
          </a-form-model-item>
          <a-form-model-item>
            <a-button @click="getIndustryCategory" type="primary"> 查询 </a-button>
          </a-form-model-item> -->
          <a-form-model-item style="margin-left:30px;">
            <a-button  v-hasPermi="['system:IndustryClassification:add']" @click="$refs.createForm.handleAdd()" ghost icon="plus" type="primary"> 新增 </a-button>
          </a-form-model-item>
        </div>
      </a-form-model>
    </div>
    <div>
      <a-table
        :loading="loading"
        :pagination="false"
        rowKey="id"
        @change="handleChangeInTable"
        :columns="columns"
        :expandedRowKeys="expandedKeys"
        @expand="onExpandCurrent"
        :data-source="bigClassificationList"
      >
        <span slot="expandedRowRender" slot-scope="text">
          <Classdetail
            @ok="getIndustryCategory"
            :parentId="text.id"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record,1)" v-hasPermi="['system:IndustryClassification:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['system:IndustryClassification:remove']"> <a-icon type="delete" />删除 </a>
        </span>
      </a-table>
    </div>
    <!-- 新增修改 -->
    <CreateDataForm @ok="getIndustryCategory" ref="createForm" :industryCategoryType="1" />
  </div>
</template>
<script>
import { industryCategoryList, deleteIndustryCategory } from '@/api/system/industry'
import Classdetail from './modules/classification.vue'
import CreateDataForm from './modules/CreateDataForm.vue'
const columns = [
  { title: '行业', dataIndex: 'industryCategoryName', key: 'industryCategoryName' },
  { title: '分类', dataIndex: 'industryCategoryType', key: 'industryCategoryType' },
  {
    title: '操作',
    dataIndex: 'operation',
    width: '15%',
    scopedSlots: { customRender: 'operation' },
    align: 'center'
  }
]
export default {
  name:'System/IndustryClassification/index',
  components: {
    Classdetail,
    CreateDataForm

  },
  data () {
    return {
      columns,
      bigClassificationList: [],
      form: {
        industryCategoryName: ''
      },
      loading: false,
      expandedKeys: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      // 分页参数
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: false,
        showSizeChanger: true,
        total: 0
      },
      open: false
    }
  },
  methods: {
    // 分类列表
    getIndustryCategory () {
      if (this.form.industryCategoryName) {
        this.pagination.current = 1
      }
      const parmars = {
        industryCategoryType: 1,
        industryCategoryName: this.form.industryCategoryName
      }
      this.loading = true
      industryCategoryList(parmars).then((res) => {
        const { code, data } = res
        this.loading = false
        if (code === 200) {
          this.bigClassificationList = data
        }
      })
    },
    handleChangeInTable (pagination, filters, sorter) {
      // 分页、排序、筛选变化时触发
      this.pagination = pagination
      this.getIndustryCategory()
      // }
    },
    // 获取详情
    onExpandCurrent (expandedKeys, row) {
      if (expandedKeys) {
        this.expandedKeys = [row.id]
      } else {
        this.expandedKeys = []
      }
    },
    // 删除行业分类
    handleDelete (record) {
      deleteIndustryCategory(record.id).then(({ code }) => {
        if (code === 200) {
          this.$message.success('删除成功')
          this.getIndustryCategory()
        }
      })
    },
    handleDetails (record) {
      this.open = true
    }
  },
  created () {
    this.getIndustryCategory()
  }
}
</script>

<style scoped lang="less">
.classification {
  background-color: #fff;
  padding: 20px;
  .search-box {
    .box-inline {
      display: flex;
    }
  }
}
</style>
